import React, { Component } from "react";

import MC1 from "../data/gallery2/Credobank_1.jpg";
import MC2 from "../data/gallery2/Credobank_2.jpg";
import MC3 from "../data/gallery2/Credobank_3.jpg";
import MC4 from "../data/gallery2/Credobank_4.jpg";
import MC5 from "../data/gallery2/Credobank_5.jpg";
import MC6 from "../data/gallery2/Credobank_6.jpg";
import MC7 from "../data/gallery2/Credobank_7.jpg";
import MC8 from "../data/gallery2/Credobank_8.jpg";
import MC9 from "../data/gallery2/Intelexpress_1.jpg";
import MC10 from "../data/gallery2/Terabank_1.jpg";
import MC11 from "../data/gallery2/Terabank_2.jpg";
import MC12 from "../data/gallery2/Terabank_3.jpg";



import PhotoGallery from "../photoGallery";

const DEFAULT_PHOTOS = [
  { id: 1, frame: "1", src: MC1, ratio: "wide" },
  { id: 2, frame: "2", src: MC2, ratio: "short" },
  { id: 3, frame: "3", src: MC3, ratio: "short" },
  { id: 4, frame: "4", src: MC4, ratio: "short" },
  { id: 5, frame: "5", src: MC5, ratio: "wide" },
  { id: 6, frame: "6", src: MC6, ratio: "short" },
  { id: 7, frame: "7", src: MC7, ratio: "wide" },
  { id: 8, frame: "8", src: MC8, ratio: "short" },
  { id: 9, frame: "9", src: MC9, ratio: "short" },
  { id: 10, frame: "10", src: MC10, ratio: "short" },
  { id: 11, frame: "11", src: MC11, ratio: "short" },
    { id: 12, frame: "12", src: MC12, ratio: "short" },
];



class CRAGallery extends Component {
  state = {
    activeIndex: null,
  };
   constructor(props) {
        super(props);
        window.scrollTo(0, 0);
    }

  

  render() {

    return (
      <div>
        <PhotoGallery 
            photos={DEFAULT_PHOTOS}
            onlanguage={this.props.onlanguage}
            onChangeLanguage={this.props.onChangeLanguage}
            onEngLanguage={this.props.onEngLanguage}
            onGeoLanguage={this.props.onGeoLanguage}
        />
      </div>
    );
  }
}

export default CRAGallery;